export default "__VITE_ASSET__G23bSKHJ__"